import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON013_Request,
  IAPI_CON013_Response,
} from "../../../type/apiType";

import {
  IAPI_CON006_Request,
  IAPI_CON006_Response,
} from "../../../type/apiType";

// 社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届更新API
const httpIAPI_CON013 = async (
  param: IAPI_CON013_Request
): Promise<IAPI_CON013_Response> => {
  let res = await http.post(ApiUrl.API_CON013, {
    ...param,
  });

  return res.data;
};

// 社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届参照API
const httpIAPI_CON006 = async (
  param: IAPI_CON006_Request
): Promise<IAPI_CON006_Response> => {
  let res = await http.post(ApiUrl.API_CON006, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_CON013, httpIAPI_CON006 };
